import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=37e517e3&scoped=true&"
import script from "./serviceAgreement.vue?vue&type=script&lang=js&"
export * from "./serviceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./serviceAgreement.vue?vue&type=style&index=0&id=37e517e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e517e3",
  null
  
)

component.options.__file = "serviceAgreement.vue"
export default component.exports